import { Color3, type LinesMesh, MeshBuilder, type Scene, Vector3 } from "@babylonjs/core";
import type { PlotInfo } from "../net/api";
import { boundaryColor, outlinePoints } from "../world/plots";

/** One outline per plot (spec §15.2: boundaries must be visible). */
export class PlotBounds {
  private lines = new Map<string, { mesh: LinesMesh; key: string }>();

  constructor(private readonly scene: Scene, private readonly height: (x: number, z: number) => number) {}

  sync(plots: readonly PlotInfo[]): void {
    const seen = new Set<string>();
    for (const p of plots) {
      seen.add(p.id);
      const key = `${p.owner_id ?? ""}|${p.bounds.min.join(",")}|${p.bounds.max.join(",")}`;
      const cur = this.lines.get(p.id);
      if (cur?.key === key) continue;
      cur?.mesh.dispose();
      const mesh = MeshBuilder.CreateLines(`plot:${p.id}:outline`, {
        points: outlinePoints(p.bounds, this.height).map(([x, y, z]) => new Vector3(x, y, z)),
      }, this.scene);
      mesh.color = Color3.FromHexString(boundaryColor(p));
      mesh.isPickable = false;
      this.lines.set(p.id, { mesh, key });
    }
    for (const [id, l] of [...this.lines]) if (!seen.has(id)) { l.mesh.dispose(); this.lines.delete(id); }
  }
}
